import React, { useState, useEffect } from 'react'
import TagManager from 'react-gtm-module'
import Favorites from '../../Favorites'
import { favoritesContainer } from 'src/models'
import './styles.scss'
import { trackGTMEvents } from 'src/utils'
import { pageNames } from 'src/routes/pathParams'

function Favourites() {
  const [myAccountFavorites, setMyAccountFavorites] = useState([])

  const { favoritesPageProducts, favoritesCount, favoritesListId } =
    favoritesContainer

  useEffect(() => {
    setMyAccountFavorites(favoritesPageProducts)
    trackGTMEvents({
      event: 'nuskin-profile',
      eventType: 'Favourites',
    })
  }, [favoritesCount])

  function selectfavoritesListProductsPropertiesForGTM(
    favoritesListProductKeys
  ) {
    const { id, listItemId, key, name } = favoritesListProductKeys
    return { id, listItemId, key, name }
  }

  if (myAccountFavorites.length > 0) {
    const favoritesListProductsForGTM = myAccountFavorites.map(
      selectfavoritesListProductsPropertiesForGTM
    )
    TagManager.dataLayer({
      dataLayer: {
        event: 'NuskinProfileFavoritePage',
        pagePath: pageNames.myaccountfavourites,
        pageTitle: 'Favorites',
        favoritesCount: favoritesCount || null,
        favoritesListId: favoritesListId || null,
        favoritesListProducts: favoritesListProductsForGTM || null,
        platform: 'equinox',
      },
    })
  }
  return (
    <section className="fav-wrapper">
      <div className="fav-products">
        <Favorites />
      </div>
    </section>
  )
}

export { Favourites }

export default Favourites
